var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H4a2 2 0 00-2 2v3a2 2 0 002 2v11a2 2 0 002 2h20a2 2 0 002-2V13a2 2 0 002-2V8a2 2 0 00-2-2zm-2 18H6V13h20v11zm2-13H4V8h24v3zm-16 6a1 1 0 011-1h6a1 1 0 010 2h-6a1 1 0 01-1-1z"
  })));
}
export default SvgArchiveRegular;